import { useState } from 'react';
import ReactSlider from 'react-slider';
import ReactTooltip from 'react-tooltip';
import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/outline';

interface IVoluneBar {
  volume: number;
  muted: boolean;
  onTimeUpdate: (e: number) => void;
  handleMute: () => void;
}
export default function VolumeBar(props: IVoluneBar) {
  const { onTimeUpdate, volume, handleMute, muted } = props;

  const [curPercentage, setCurPercentage] = useState(volume * 100);
  const [isHovered, setIsHovered] = useState(true);

  function handleTimeDrag(e: number) {
    setCurPercentage(e * 100);
    onTimeUpdate(e);
  }

  const handleHoverLeave = () => setIsHovered(true);
  const handleMouseEnter = () => setIsHovered(false);

  return (
    <div
      className="flex justify-start gap-x-2 items-center w-28 m:w-14"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleHoverLeave}
    >
      {curPercentage && !muted ? (
        <>
          <SpeakerWaveIcon
            data-tip
            data-for="mute"
            data-delay-show="300"
            className="mr-2 h-5 w-5 cursor-pointer text-white"
            onClick={handleMute}
          />
          <ReactTooltip id="mute" place="top" effect="solid" delayShow={300}>
            Mute
          </ReactTooltip>
        </>
      ) : (
        <>
          <SpeakerXMarkIcon
            data-tip
            data-for="unmute"
            data-delay-show="300"
            className="mr-2 h-5 w-5 cursor-pointer text-white"
            onClick={handleMute}
          />
          <ReactTooltip id="unmute" place="top" effect="solid" delayShow={300}>
            Unmute
          </ReactTooltip>
        </>
      )}
      <div
        className={`${
          isHovered
            ? 'ease-ou duration-300'
            : 'flex-1 h-1 rounded-sm flex ease-in duration-300'
        }`}
        style={{
          background: `linear-gradient(to right,${
            muted ? '#c3cee3' : '#F14E22'
          }  ${curPercentage}%, #c3cee3 0)`,
        }}
        onClick={muted ? handleMute : undefined}
      >
        <ReactSlider
          className={`flex-1 h-1 rounded-sm flex items-center cursor-pointer`}
          thumbClassName={`cursor-pointer border-white rounded-lg bg-red-500  ${
            isHovered ? 'h-0 w-0' : 'h-3 w-3'
          }`}
          trackClassName="example-track"
          value={muted ? 0 : volume * 100}
          onChange={(value: number) => {
            handleTimeDrag(value / 100);
          }}
        />
      </div>
    </div>
  );
}
